import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useContext } from 'react';
import { UserContext } from '../UserContext';
import api from '../api';
import { useEffect } from 'react';
import { useTranslation } from '../LanguageContext';

function GeneralData() {
    const { user, setUser } = useContext(UserContext);
    const { t } = useTranslation();
    const [username, setUsername] = useState(user.username);
    const [nameSuccess] = useState("");
    const [errors, setErrors] = useState([]);
    // const match = user.date_joined.match(/^\d{4}-\d{2}-\d{2}/);
    // const formattedDate = match ? match[0] : null;


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (username === user.username) {
            return;
        }
        try {
            const res = await api.put("/api/update-user/", { username });
            if (res.status === 200) {
                setErrors(["name changed"]);
                setUser({ ...user, username: username });
            }
        }
        catch (error) {
            setErrors([error.response.data.username[0]]);
        }

    }

    return (<>
        <div className="card mb-4">
            {/* <h3 className="text-lg font-semibold text-slate-800 mb-4">{t('account.generalInfo')}</h3> */}
            <form onSubmit={handleSubmit} className="space-y-4">
                {/* <div className="flex items-center gap-3 px-4 py-3 bg-slate-50 rounded-xl"> */}
                    {/* <span className="text-sm text-slate-500">{t('account.accountOpened')}</span> */}
                    {/* <span className="text-sm font-medium text-slate-700">{formattedDate}</span> */}
                {/* </div> */}

                <div>
                    <label className="text-lg font-semibold text-slate-800 mb-3">{t('account.changeName')}</label>


                    <input
                        placeholder={t('account.usernamePlaceholder')}
                        className="input"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        maxLength={30}
                        required
                    />
                </div>

                {nameSuccess && (
                    <p className="text-sm text-emerald-600 font-medium">{nameSuccess}</p>
                )}
                {errors.length > 0 && (
                    <ul className="list-none p-0 space-y-1">
                        {errors.map((error, index) => (
                            <li key={index} className="text-sm text-red-600">{`${error}`}</li>
                        ))}
                    </ul>
                )}

                <button type="submit" className="btn-secondary">
                    {t('account.saveBtn')}
                </button>
            </form>
        </div>
    </>)
}

function ChangeMail() {
    const { user, setUser } = useContext(UserContext);
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [countdown, setCountdown] = useState(60);
    const [validate_input, setvalidate_input] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [validate_code, setvalidate_code] = useState("");
    const [errors, setErrors] = useState([]);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => {
        setShow(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (email === user.email) {
                setErrors([t('account.usingThisEmail')]);
                return;
            }
            setLoading(true);
            setErrors([]);
            const res = await api.put("api/update-email/", { email, code: validate_code });
            setLoading(false);
            if (res.status === 201) {
                setUser({ ...user, email: email });
                handleClose();
            }
            if (res.status === 200) {
                // Awaited so a code that never went out cannot advance the
                // form to "enter your code" — the catch below already knows
                // how to show the server's `email` error.
                await api.post("api/CreateVCode/", { email })
                setErrors([t('account.codeSent')]);
                setvalidate_input(true)
                setIsActive(false)
            }
            if (res.status === 208) {
                setErrors([t('account.codeSent')]);
                setvalidate_input(true)
            }
        }
        catch (error) {
            setLoading(false);
            if (error.response.data.code) {
                setErrors([error.response.data.code[0]]);
            }
            if (error.response.data.email) {
                setErrors([error.response.data.email[0]]);
            }
            if (error.response.data.non_field_errors) {
                setErrors([error.response.data.non_field_errors[0]]);
            }
        }
    }
    const handleClick = async () => {
        try {
            await api.post("api/CreateVCode/", { email });
            setErrors([t('account.codeSent')]);
            setIsActive(false);
        } catch (error) {
            const data = error?.response?.data ?? {};
            setErrors([data.email?.[0] ?? t('account.codeNotSent')]);
        }
    };
    const handleClose = () => {
        setErrors([]);
        setIsActive(false);
        setvalidate_input(false);
        setvalidate_code("");
        setCountdown(0)
        setEmail("");
        setShow(false);
    }

    useEffect(() => {
        let interval = null;

        if (!isActive && countdown > 0) {
            interval = setInterval(() => {
                setCountdown((countdown) => countdown - 1);
            }, 1000);
        } else if (countdown === 0) {
            clearInterval(interval);
            setIsActive(true);
            setCountdown(60);
        }

        return () => clearInterval(interval);
    }, [isActive, countdown]);

    return (<>
        <div className="card mb-4">
            <h3 className="text-lg font-semibold text-slate-800 mb-3">{t('account.emailTitle')}</h3>
            <div className="flex items-center gap-3">
                <input type="text" className="input flex-1" value={user.email} disabled placeholder={user.email} />
                {!user.third_party &&
                    <button className="btn-secondary whitespace-nowrap" type="button" onClick={handleShow}>
                        {user.email ? t('account.changeBtn') : t('account.addBtn')}
                    </button>
                }
            </div>
        </div>

        {/* Change email modal */}
        {show && (
            <div className="modal-overlay" onClick={handleClose}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" onClick={e => e.stopPropagation()}>
                    <div className="px-6 py-4 border-b border-slate-100">
                        <h2 className="text-lg font-semibold text-slate-800">{t('account.changeEmailTitle')}</h2>
                    </div>
                    <div className="p-6">
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <input
                                className="input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={t('account.newEmailPlaceholder')}
                                maxLength={254}
                                required
                            />

                            {errors.length > 0 && (
                                <ul className="list-none p-0 space-y-1">
                                    {errors.map((error, index) => (
                                        <li key={index} className="text-sm text-amber-600">{` ${error}`}</li>
                                    ))}
                                </ul>
                            )}

                            {validate_input && (
                                <div className="space-y-3">
                                    <div className="flex gap-2">
                                        <input
                                            placeholder={t('account.enterCodePlaceholder')}
                                            className="input flex-1"
                                            value={validate_code}
                                            onChange={(e) => setvalidate_code(e.target.value)}
                                            pattern="\d{6}"
                                            maxLength={6}
                                        />
                                        <button
                                            type="button"
                                            className="btn-secondary text-sm"
                                            onClick={handleClick}
                                            disabled={!isActive}
                                        >
                                            {isActive ? t('account.resendBtn') : `${countdown}s`}
                                        </button>
                                    </div>
                                    <p className="text-xs text-slate-400">{t('account.checkSpam')}</p>
                                </div>
                            )}

                            <button
                                className="btn-primary w-full flex items-center justify-center"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? <div className="spinner-sm"></div> : t('account.submitBtn')}
                            </button>
                        </form>
                    </div>
                    <div className="px-6 py-3 bg-slate-50 flex justify-end">
                        <button type="button" className="btn-secondary text-sm" onClick={handleClose}>{t('account.closeBtn')}</button>
                    </div>
                </div>
            </div>
        )}
    </>)
}

function ChangePassword() {
    const { t } = useTranslation();
    const [Current, setCurrent] = useState("");
    const [New, setNew] = useState("");
    const [Confirm, setConfirm] = useState("");
    const [errors, setErrors] = useState([]);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => {
        setShow(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Current === New) {
            setErrors([t('account.passwordSameAlert')]);
            return;
        }
        if (New !== Confirm) {
            setErrors([t('account.passwordsNotMatch')]);
            return;
        }
        try {
            setLoading(true);
            setErrors([]);
            const res = await api.put("/api/update-password/", { old_password: Current, new_password: New })
            setLoading(false);
            if (res.status === 200) {
                setErrors([t('account.passwordChanged')]);
            }
        }
        catch (error) {
            setLoading(false);
            if (error.response.data.new_password) {
                setErrors([error.response.data.new_password[0]]);
            }
            if (error.response.data.old_password) {
                setErrors([error.response.data.old_password[0]]);
            }
        }
    }

    const handleClose = () => {
        setErrors([]);
        setShow(false);
        setCurrent("");
        setNew("");
        setConfirm("");
    }

    return (<>
        <div className="card mb-4">
            <h3 className="text-lg font-semibold text-slate-800 mb-3">{t('account.passwordTitle')}</h3>
            <button className="btn-secondary" type="button" onClick={handleShow}>{t('account.changePasswordBtn')}</button>
        </div>

        {/* Change password modal */}
        {show && (
            <div className="modal-overlay" onClick={handleClose}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" onClick={e => e.stopPropagation()}>
                    <div className="px-6 py-4 border-b border-slate-100">
                        <h2 className="text-lg font-semibold text-slate-800">{t('account.changePasswordTitle')}</h2>
                    </div>
                    <div className="p-6">
                        <form onSubmit={handleSubmit} className="space-y-4">
                            <input
                                className="input"
                                type="password"
                                value={Current}
                                onChange={(e) => setCurrent(e.target.value)}
                                placeholder={t('account.currentPasswordPlaceholder')}
                                pattern="\S+"
                                title="Password cannot contain spaces"
                                maxLength={128}
                                minLength={8}
                                required
                            />
                            <Link to="/reset_password" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">
                                {t('account.forgotPasswordLabel')}
                            </Link>

                            <hr className="border-slate-100" />

                            <input
                                className="input"
                                type="password"
                                value={New}
                                onChange={(e) => setNew(e.target.value)}
                                placeholder={t('account.newPasswordPlaceholder')}
                                pattern="\S+"
                                title="Password cannot contain spaces"
                                maxLength={128}
                                minLength={8}
                                required
                            />
                            <input
                                className="input"
                                type="password"
                                value={Confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                placeholder={t('account.confirmPasswordPlaceholder')}
                                pattern="\S+"
                                title="Password cannot contain spaces"
                                maxLength={128}
                                minLength={8}
                                required
                            />

                            {errors.length > 0 && (
                                <ul className="list-none p-0 space-y-1">
                                    {errors.map((error, index) => (
                                        <li key={index} className="text-sm text-amber-600">{` ${error}`}</li>
                                    ))}
                                </ul>
                            )}

                            <p className="text-xs text-slate-400">{t('account.terminateSessions')}</p>

                            <button
                                className="btn-primary w-full flex items-center justify-center"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? <div className="spinner-sm"></div> : t('account.saveBtn')}
                            </button>
                        </form>
                    </div>
                    <div className="px-6 py-3 bg-slate-50 flex justify-end">
                        <button type="button" className="btn-secondary text-sm" onClick={handleClose}>{t('account.closeBtn')}</button>
                    </div>
                </div>
            </div>
        )}
    </>)
}

function Important() {
    const { t } = useTranslation();
    const { user } = useContext(UserContext);
    const [show, setShow] = useState(false);
    const [Verify, setVerify] = useState("");
    const navigate = useNavigate();
    const [warning, setwarning,] = useState(false);

    // Cancelling happens on the finance page now, in the app. This used to open
    // the Stripe billing portal in place of it.
    const handleManageSubscription = () => {
        setShow(false);
        navigate('/finance');
    }

    const handleShow = () => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setVerify("");
        setwarning(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Verify !== `delete${user.username}`) {
            return;
        }
        try {
            const res = await api.delete("/api/delete-user/");
            if (res.status === 200) {
                navigate("/logout");
            }

        }
        catch (error) {
            if (error.status === 400) {
                setwarning(true);
            }
        }
    }

    return <>
        <div className="card mb-4">
            {/* <h3 className="text-lg font-semibold text-red-700 mb-4"></h3> */}
            <div className="space-y-3">
                <Link to="/logout">
                    <button type="button" className="btn-danger w-full">{t('account.logoutBtn')}</button>
                </Link>
                <button type="button" onClick={handleShow} className="w-full px-6 py-2.5 bg-white text-red-600 font-semibold rounded-xl border-2 border-red-200 hover:bg-red-50 transition duration-200">
                    {t('account.deleteAccountBtn')}
                </button>
            </div>
        </div>

        {/* Delete account modal */}
        {show && (
            <div className="modal-overlay" onClick={handleClose}>
                <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 overflow-hidden" onClick={e => e.stopPropagation()}>
                    <div className="px-6 py-4 border-b border-slate-100">
                        <h2 className="text-lg font-semibold text-red-700">{t('account.deleteAccountBtn')}</h2>
                    </div>
                    <div className="p-6 space-y-4">
                        <form onSubmit={handleSubmit} className="space-y-3">
                            <p className="text-sm text-slate-600">
                                {t('account.confirmDelete')} <span className="font-bold text-slate-900">"delete{user.username}"</span> {t('account.confirmDeleteSuffix')}
                            </p>
                            <input
                                className="input"
                                type="text"
                                value={Verify}
                                onChange={(e) => setVerify(e.target.value)}
                                maxLength={254}
                                required
                            />
                        </form>
                        {warning && (
                            <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
                                <p className="text-sm text-amber-700">{t('account.activeSubAlert')}</p>
                            </div>
                        )}
                    </div>
                    <div className="px-6 py-3 bg-slate-50 flex justify-end gap-3">
                        <button type="button" className="btn-secondary text-sm" onClick={handleClose}>{t('account.cancelBtn')}</button>
                        {warning ?
                            <button className="btn-secondary text-sm" type="button" onClick={handleManageSubscription}>{t('account.manageSubBtn')}</button>
                            :
                            <button type="button" onClick={handleSubmit} className="btn-danger text-sm">{t('account.deleteBtn')}</button>
                        }
                    </div>
                </div>
            </div>
        )}
    </>
}

function Account() {
    const { user } = useContext(UserContext);

    return (<div className="w-full mt-4 mb-8">
        <div className="space-y-4">
            <GeneralData />
            <ChangeMail />
            {!user.third_party && <ChangePassword />}
            <Important />
        </div>
    </div>
    )
}

export default Account
export { GeneralData, ChangeMail, ChangePassword, Important }